import { Color, ColorFill, PointerEvents, SvgGraphics } from '@tencent/alloy-renderer';
import {
    IGuideLineComponent,
} from '@src/slide/content-viewer/service/canvas-renderer/entry/base/feature/component/guide-component/interface/guide-line.interface';
import { resizeCol } from '../../../../../pc-edit/logic/table-edit-layer/cursor';
import {
    BaseGuideLine, IGuideLineGraphicsProps,
} from '@src/slide/content-viewer/service/canvas-renderer/entry/base/feature/component/guide-component/components/guide-line';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

/**
 * 垂直参考线图形
 */
export class VertGuideLine extends BaseGuideLine implements IGuideLineComponent {
    public constructor(props: IGuideLineGraphicsProps) {
        super(props);
        const { position, color } = this.props;
        this.renderGuideLine(position, color);
    }

    public renderGuideLine = (position: number, color: string) => {
        if (this.props.isUiComponent) {
            this.renderUiGuideLine(position, color);
        } else {
            this.renderEventGuideLine(position);
        }
    };

    public renderUiGuideLine = (position: number, color: string) => {
        const { canvasHeight, scale } = this.getAppService()
            .viewableServiceLayer.editAreaCanvasSizeManager.getCanvasSize();
        const top = 0;
        const bottom = canvasHeight / scale;
        const left = position;
        const lineColor = color?.replace(/#/, '');

        const path = `M ${left} ${top} L ${left} ${bottom}`;
        if (!this.lineComponent) {
            this.lineComponent = new SvgGraphics(path);
            this.lineComponent.pointerEvents = PointerEvents.NONE;
            this.lineComponent.stroke = new ColorFill(Color.fromHex(
                `#${lineColor}` || this.defaultLineColor,
                this.defaultAlpha,
            ));
            this.lineComponent.strokeWidth = 1 / scale;
            this.lineComponent.strokeDash = [6, 4];
            this.addChild(this.lineComponent);
        } else {
            this.lineComponent.stroke = new ColorFill(Color.fromHex(
                `#${lineColor}` || this.defaultLineColor,
                this.defaultAlpha,
            ));
            this.lineComponent.path = path;
        }
    };

    public renderEventGuideLine = (position: number) => {
        const { canvasHeight, scale } = this.getAppService()
            .viewableServiceLayer.editAreaCanvasSizeManager.getCanvasSize();
        const top = 0;
        const bottom = canvasHeight / scale;
        const left = position - this.hotEventLength;
        const right = position + this.hotEventLength;
        const { canEdit } = this.props;
        const pointerEvents = !canEdit ? PointerEvents.NONE : PointerEvents.AUTO;

        const path = `M ${left} ${top} L ${right} ${top} L ${right} ${bottom} L ${left} ${bottom} Z`;
        if (!this.lineComponent) {
            this.lineComponent = new SvgGraphics(path);
            this.lineComponent.fill = new ColorFill(Color.Transparent);
            this.lineComponent.cursor = resizeCol;
            this.lineComponent.pointerEvents = pointerEvents;
            this.lineComponent.onContextMenu(this.handleContextMenu);
            this.lineComponent.onMouseDown(this.handleMouseDown);
            this.lineComponent.onDoubleClick(this.handleDoubleClick);
            this.addChild(this.lineComponent);
        } else {
            this.lineComponent.path = path;
        }
    };

    private getAppService = () => AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
}
